import React from "react";

import { Checkbox, FormControlLabel } from "@mui/material";

interface Props {
  label: string;
  checked: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
}

export const CheckRow: React.FC<Props> = ({ label, checked, onChange, disabled }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          size="small"
          sx={{ p: "2px", "& .MuiSvgIcon-root": { fontSize: 18 } }}
        />
      }
      label={label}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
        m: 0,
        mb: "4px",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.45 : 1,
        "& .MuiFormControlLabel-label": { fontSize: 13, color: disabled ? "#9CA3AF" : "#374151" }
      }}
    />
  );
};
